module.exports = __webpack_public_path__ + "img/pi-2-1.510b4662.png";